import { Dialog } from "@headlessui/react";
import Button from "../../../components/button/Button";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AuthUser, Pass, newAuthUser } from "../../../model/Auth";
import { staffSchema } from "../../../model/Staff";
import FormController from "../../../components/fields/FormController";
import { FormBox, ModalFoterBox, ModalHeaderBox, } from "../../../components/box/Box";
import { useEffect } from "react";
import { ConstMessage, SessionKey } from "../../../config/const";
import { TextField } from "../../../components/fields/Fields";

export type StaffProps = {
  authUser?: AuthUser & Pass;
  updateFlg?: boolean | null;
  onSubmit: (auth: AuthUser & Pass) => Promise<void>;
};

export const StaffEditModal = ({
  open,
  toggle,
  closeOnClickOutside,
  authUser = newAuthUser(),
  updateFlg = false,
  onSubmit,
}: ModalProp & StaffProps) => {
  const { control, handleSubmit, setValue, reset, watch } = useForm<AuthUser & Pass>({
    resolver: yupResolver(staffSchema),
    defaultValues: authUser,
  });

  useEffect(() => {
    if(updateFlg){
      setValue("email", authUser.email);
      setValue("displayName", authUser.displayName);
      setValue("pass", authUser.pass);
    }
    setValue("updateFlg", updateFlg);
  }, [
    authUser.displayName, authUser.email, authUser.pass,
    updateFlg, setValue, open
  ]);

  useEffect(() => {
    if(!open) {
      reset();
    };
  },[open, reset]);

  // email更新時
  useEffect(() => {
    // EMAIL重複チェック結果を初期化
    sessionStorage.setItem(SessionKey.HAS_DUPLICATED_STAFF_MAIL, "false");
    // 入力値更新
    setValue("email", watch("email"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[watch("email")]);
  
  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <ModalHeaderBox
                title={"管理者登録"}
                Subtitle={`${updateFlg? '編集': '新規登録'}する管理者情報を入力してください`}
              />
              <FormBox>
              <Controller
                  control={control}
                  name={"email"}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      type={"email"}
                      label={"メールアドレス"}
                      required
                      error={fieldState.error || sessionStorage.getItem(SessionKey.HAS_DUPLICATED_STAFF_MAIL) === "true"}
                      helperText={fieldState.error?.message || (sessionStorage.getItem(SessionKey.HAS_DUPLICATED_STAFF_MAIL) === "true" ? ConstMessage.WARN_REGISTED_ADMIN_EMAIL : "")}
                      autoComplete={'new-email'}
                    />
                  )}
                />
                <FormController
                  control={control}
                  name={"displayName"}
                  label={"名前"}
                  type={"text"}
                  required
                  autoComplete={'off'}
                />
              </FormBox>
              <FormBox>
                <FormController
                  control={control}
                  name={"pass"}
                  label={"パスワード"}
                  type={"password"}
                  required
                  autoComplete={'new-password'}
                />
              </FormBox>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mr-2 w-[132px]"
              outline
              color={"indigo"}
              onClick={toggle}
              children={"キャンセル"}
            />
            <Button
              submit
              className="w-[132px]"
              children={"登録"}
            />
          </ModalFoterBox>
        </form>
      </Dialog.Panel>
    </Modal>
  );
};
